import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    appName: '',
  },
  mutations: {
    setAppName(state, value) {
      state.appName = value;
    }
  },
  actions: {
    getVersionId({ commit }) {
      const configName = {
        0: '对对',
        1: '心甜',
        2: "心配",
        3: "依恋",
        4: "缘已"
      };
      const SearchURL = window.location.search || window.location.hash.split('?')[1];
      const search = new URLSearchParams(SearchURL);
      const vestID = search.get('vestId') || 0;
      console.log('vestID:', vestID);
      commit('setAppName', configName[vestID]);
    }
  }
});


export default store;
